"use strict";

module.exports = function (accumulator, order, product, component) {
  var productTypeForPrinting = component.place_card_style.match(/flat/i) ? 'FlatPlaceCard' : 'FoldPlaceCard';
  return accumulator + '-' + productTypeForPrinting;
};